"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgDownloadDoc(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M13.974 0a.75.75 0 01.546.226l6.127 6.127a.75.75 0 01.226.523l-.002.019v15.318a1.79 1.79 0 01-1.64 1.781l-.147.006H4.787a1.79 1.79 0 01-1.781-1.64L3 22.212V1.789A1.79 1.79 0 014.64.007l.147-.005zm-.762 1.533H4.787a.26.26 0 00-.248.198l-.007.058v20.424a.26.26 0 00.197.248l.058.007h14.297a.26.26 0 00.249-.197l.006-.058V7.66h-5.361A.766.766 0 0113.219 7l-.007-.104V1.533zm-1.276 9.702c.423 0 .766.343.766.766l-.001 5.3 1.757-1.757.086-.074a.766.766 0 01.997 1.157l-3.064 3.064-.086.074a.766.766 0 01-.997-.074L8.33 16.627l-.074-.086a.766.766 0 01.074-.997l.086-.074a.766.766 0 01.998.074l1.755 1.756V12l.008-.103a.766.766 0 01.759-.662zm2.808-8.618v3.512h3.512l-3.512-3.512z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgDownloadDoc;
exports.default = _default;